// extracted by mini-css-extract-plugin
export var amex = "PaymentMethod_amex__3CeBz";
export var applepay = "PaymentMethod_applepay__qjGfl";
export var cardDetails = "PaymentMethod_cardDetails__xxF5i";
export var cardType = "PaymentMethod_cardType__NthNL";
export var dinersclub = "PaymentMethod_dinersclub__cDggb";
export var discover = "PaymentMethod_discover__m+nEh";
export var jcb = "PaymentMethod_jcb__Px4Ve";
export var mastercard = "PaymentMethod_mastercard__2I8GQ";
export var paypal = "PaymentMethod_paypal__IuMSj";
export var venmo = "PaymentMethod_venmo__7vxBg";
export var visa = "PaymentMethod_visa__LX9sT";
export var wrapper = "PaymentMethod_wrapper__0u01L";